<fieldset>
    <legend>Echantillonnage*</legend>
    <div class="flex flex-wrap gap-3 state-container">
      <mat-radio-group [formControl]="valueFormControl">
        <mat-radio-button *ngFor="let item of stationSamplings"
                          [value]="item.value"
                          [color]="'primary'">{{ item.label }}
        </mat-radio-button>
      </mat-radio-group>
    </div>
  </fieldset>
